<div class="ds">

  <div class="ds-cabecera">
    <button type="button" class="ds-btn-volver"
            title="{{ 'BTN_REGRESAR' | translate }}" (click)="regresar()">
      <img src="assets/icons/ico-volver.svg" alt="">
    </button>

    <app-admsb-encabezado *ngIf="!cargandoPasarela" [idTercero]="idTercero" [idTitular]="idTitular"
                          [idSolicitudUnidadCredito]="idSolicitudUnidadCredito"
                          (titularCargado)="titular = $event">
    </app-admsb-encabezado>
  </div>

  <app-admsb-unidad-productiva *ngIf="!cargandoPasarela" [idSolicitudUCUnidadProductiva]="idSolicitudUCUnidadProductiva">
  </app-admsb-unidad-productiva>

  <app-admsb-tarifas-tabla [idTitular]="idTitular"></app-admsb-tarifas-tabla>

  <app-admsb-adjuntos-tabla [idTitular]="idTitular"></app-admsb-adjuntos-tabla>

  <app-admsb-contratos-tabla [idTitular]="idTitular"></app-admsb-contratos-tabla>

  <app-admsb-contactos-tabla [idTitular]="idTitular" [telefonoTitular]="titular?.telefono"
                             [correoTitular]="titular?.correo"></app-admsb-contactos-tabla>

</div>
